export const DEVICE_FINGERPRINT_SCRIPT_ID = 'deviceFingerprintScriptTag';
export const DEVICE_FINGERPRINT_SCRIPT_ID_ASYNC = 'deviceFingerprintScriptTagAsync';
